/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Switch_1Inputs */

const en_fc_vs_switch_1 = /** @type {(inputs: Fc_Vs_Switch_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Premiere, export your sequence via File → Export → Final Cut Pro XML (or AAF / EDL).`)
};

/**
* | output |
* | --- |
* | "In Premiere, export your sequence via File → Export → Final Cut Pro XML (or AAF / EDL)." |
*
* @param {Fc_Vs_Switch_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_switch_1 = /** @type {((inputs?: Fc_Vs_Switch_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Switch_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_switch_1(inputs)
});
export { fc_vs_switch_1 as "fc.vs.switch.1" }